var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-toolbar",
        {
          attrs: { flat: "", color: _vm.orgLevel ? "blue lighten-4" : "white" },
        },
        [
          _c("h3", { staticClass: "headline mb-0" }, [
            _vm._v(_vm._s(_vm.section.label)),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              nativeOn: {
                click: function ($event) {
                  _vm.show = !_vm.show
                },
              },
            },
            [
              _c("v-icon", [
                _vm._v(
                  _vm._s(_vm.show ? "fas fa-chevron-up" : "fas fa-chevron-down")
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show",
            },
          ],
        },
        [
          _c("span", { staticClass: "grey--text text--darken-2" }, [
            _vm._v(_vm._s(_vm.section.description)),
          ]),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form-" + _vm.section.id,
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _vm.showSystemInfo
                ? _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: { xs12: "", sm5: "", "pa-2": "", "ma-2": "" },
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Name",
                              rules: [_vm.rules.required],
                            },
                            on: { input: _vm.change },
                            model: {
                              value: _vm.system.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.system, "name", $$v)
                              },
                              expression: "system.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          attrs: { xs12: "", sm5: "", "pa-2": "", "ma-2": "" },
                        },
                        [
                          _c("v-textarea", {
                            attrs: { label: "Description", rows: "2" },
                            on: { input: _vm.change },
                            model: {
                              value: _vm.system.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.system, "description", $$v)
                              },
                              expression: "system.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                _vm._l(_vm.section.properties, function (property, j) {
                  return _c("data-entry-field", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: property.visibleEx,
                        expression: "property.visibleEx",
                      },
                    ],
                    key: j + _vm.rerender - _vm.rerender,
                    attrs: {
                      property: property,
                      locked: property.lockedEx,
                      visible: true,
                    },
                    on: {
                      change: _vm.change,
                      linkedwindowclosed: _vm.linkedwindowclosed,
                      linkedwindowopening: _vm.linkedwindowopening,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show",
            },
          ],
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "mr-4 was-orange",
              attrs: {
                color: "primary",
                outlined: "",
                rounded: "",
                disabled: !_vm.changed,
              },
              on: {
                click: function ($event) {
                  return _vm.reset(_vm.section.id)
                },
              },
            },
            [_vm._v("Reset")]
          ),
          _vm._v(" "),
          _vm.section.needsValidation &&
          (_vm.system.hasDriver || _vm.system.isCloudSystem)
            ? _c(
                "v-btn",
                {
                  staticClass: "mr-4 was-orange",
                  attrs: {
                    color: "primary",
                    outlined: "",
                    rounded: "",
                    disabled: !_vm.valid,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.validate(_vm.section.id)
                    },
                  },
                },
                [_vm._v("Validate")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "was-orange",
              attrs: {
                color: "primary",
                rounded: "",
                disabled: !_vm.changed || !_vm.valid,
              },
              on: {
                click: function ($event) {
                  return _vm.apply(_vm.section.id)
                },
              },
            },
            [_vm._v("Save")]
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.validationMessage.length > 0
            ? _c(
                "v-alert",
                {
                  attrs: {
                    value: _vm.validationMessage,
                    type: "error",
                    outlined: "",
                  },
                },
                [_vm._v(_vm._s(_vm.validationMessage))]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "500" },
          model: {
            value: _vm.systemRemoteValidationDialog,
            callback: function ($$v) {
              _vm.systemRemoteValidationDialog = $$v
            },
            expression: "systemRemoteValidationDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm.systemRemoteValidationStatus)),
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _c("h3", [_vm._v(_vm._s(_vm.systemRemoteValidationMessage))]),
                _vm._v(" "),
                _vm.systemRemoteValidationMessages.length
                  ? _c(
                      "p",
                      [
                        _vm._v("Details:\n                            "),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            nativeOn: {
                              click: function ($event) {
                                _vm.showErrDetails = !_vm.showErrDetails
                              },
                            },
                          },
                          [
                            _c("v-icon", [
                              _vm._v(
                                _vm._s(
                                  _vm.showErrDetails
                                    ? "fas fa-chevron-up"
                                    : "fas fa-chevron-down"
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showErrDetails
                  ? _c(
                      "div",
                      _vm._l(
                        _vm.systemRemoteValidationMessages,
                        function (msg, i) {
                          return _c("p", { key: i }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(msg) +
                                "\n                    "
                            ),
                          ])
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-4 was-orange",
                      attrs: { color: "primary", outlined: "", rounded: "" },
                      on: {
                        click: function ($event) {
                          _vm.systemRemoteValidationDialog = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "300" },
          model: {
            value: _vm.waitDialog,
            callback: function ($$v) {
              _vm.waitDialog = $$v
            },
            expression: "waitDialog",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { color: "primary", dark: "" } },
            [
              _c(
                "v-card-text",
                [
                  _vm._v("\n                Please stand by\n                "),
                  _c("v-progress-linear", {
                    staticClass: "mb-0",
                    attrs: { indeterminate: "", color: "white" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }